// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-detail-page {
  width: 100%;
  min-height: 100vh;
  background: #121212;
  color: #F1F1F1;
  font-family: 'Satoshi', sans-serif;
  padding-top: 120px;
}

.article-detail-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 18px;
  color: rgba(241, 241, 241, 0.6);
}

.article-detail {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 60px 80px;
}

/* Header */
.article-detail-header {
  margin-bottom: 60px;
}

.article-detail-image {
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 12px;
  margin-bottom: 40px;
}

.article-detail-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.article-detail-meta {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.article-detail-category {
  font-size: 14px;
  font-weight: 500;
  color: #CCFF00;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.article-detail-title {
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: #F1F1F1;
  margin: 0;
}

.article-detail-description {
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.6;
  color: rgba(241, 241, 241, 0.7);
  margin: 0;
}

.article-detail-date {
  font-size: 14px;
  color: rgba(241, 241, 241, 0.5);
}

/* Content */
.article-detail-content {
  font-size: 18px;
  line-height: 1.8;
  color: rgba(241, 241, 241, 0.9);
  margin-bottom: 60px;
}

.article-detail-content h2 {
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 500;
  line-height: 1.4;
  color: #F1F1F1;
  margin-top: 48px;
  margin-bottom: 24px;
  letter-spacing: -0.01em;
}

.article-detail-content h2:first-child {
  margin-top: 0;
}

.article-detail-content h3 {
  font-size: clamp(20px, 2.5vw, 26px);
  font-weight: 500;
  line-height: 1.4;
  color: #F1F1F1;
  margin-top: 36px;
  margin-bottom: 20px;
  letter-spacing: -0.01em;
}

.article-detail-content p {
  margin-bottom: 20px;
  color: rgba(241, 241, 241, 0.85);
}

.article-detail-content ul,
.article-detail-content ol {
  margin: 24px 0;
  padding-left: 32px;
}

.article-detail-content li {
  margin-bottom: 12px;
  color: rgba(241, 241, 241, 0.85);
  line-height: 1.7;
}

.article-detail-content ul li {
  list-style-type: disc;
}

.article-detail-content ol li {
  list-style-type: decimal;
}

.article-detail-content strong {
  font-weight: 600;
  color: #F1F1F1;
}

.article-detail-content a {
  color: #CCFF00;
  text-decoration: underline;
  transition: opacity 0.3s ease;
}

.article-detail-content a:hover {
  opacity: 0.8;
}

/* Actions */
.article-detail-actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 60px;
  padding-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.article-detail-back-btn {
  padding: 14px 32px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: #F1F1F1;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Satoshi', sans-serif;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.article-detail-back-btn:hover {
  background: #CCFF00;
  color: #121212;
  border-color: #CCFF00;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .article-detail-page {
    padding-top: 100px;
  }

  .article-detail {
    padding: 0 20px 60px;
  }

  .article-detail-header {
    margin-bottom: 40px;
  }

  .article-detail-image {
    height: 300px;
    margin-bottom: 32px;
  }

  .article-detail-content {
    font-size: 16px;
    margin-bottom: 40px;
  }

  .article-detail-content h2 {
    margin-top: 36px;
    margin-bottom: 20px;
  }

  .article-detail-content h3 {
    margin-top: 28px;
    margin-bottom: 16px;
  }

  .article-detail-content ul,
  .article-detail-content ol {
    padding-left: 24px;
  }

  .article-detail-actions {
    margin-top: 40px;
    padding-top: 32px;
  }
}

@media (max-width: 480px) {
  .article-detail {
    padding: 0 16px 40px;
  }

  .article-detail-image {
    height: 250px;
    margin-bottom: 24px;
  }

  .article-detail-content {
    font-size: 15px;
  }

  .article-detail-content h2 {
    margin-top: 32px;
    margin-bottom: 16px;
  }

  .article-detail-content h3 {
    margin-top: 24px;
    margin-bottom: 12px;
  }

  .article-detail-content ul,
  .article-detail-content ol {
    padding-left: 20px;
  }

  .article-detail-back-btn {
    padding: 12px 24px;
    font-size: 14px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/use-cases/ArticleDetail.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".article-detail-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #121212;\n  color: #F1F1F1;\n  font-family: 'Satoshi', sans-serif;\n  padding-top: 120px;\n}\n\n.article-detail-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n  font-size: 18px;\n  color: rgba(241, 241, 241, 0.6);\n}\n\n.article-detail {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0 60px 80px;\n}\n\n/* Header */\n.article-detail-header {\n  margin-bottom: 60px;\n}\n\n.article-detail-image {\n  width: 100%;\n  height: 400px;\n  overflow: hidden;\n  border-radius: 12px;\n  margin-bottom: 40px;\n}\n\n.article-detail-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.article-detail-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.article-detail-category {\n  font-size: 14px;\n  font-weight: 500;\n  color: #CCFF00;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.article-detail-title {\n  font-size: clamp(28px, 4vw, 42px);\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n  color: #F1F1F1;\n  margin: 0;\n}\n\n.article-detail-description {\n  font-size: clamp(16px, 2vw, 20px);\n  line-height: 1.6;\n  color: rgba(241, 241, 241, 0.7);\n  margin: 0;\n}\n\n.article-detail-date {\n  font-size: 14px;\n  color: rgba(241, 241, 241, 0.5);\n}\n\n/* Content */\n.article-detail-content {\n  font-size: 18px;\n  line-height: 1.8;\n  color: rgba(241, 241, 241, 0.9);\n  margin-bottom: 60px;\n}\n\n.article-detail-content h2 {\n  font-size: clamp(24px, 3vw, 32px);\n  font-weight: 500;\n  line-height: 1.4;\n  color: #F1F1F1;\n  margin-top: 48px;\n  margin-bottom: 24px;\n  letter-spacing: -0.01em;\n}\n\n.article-detail-content h2:first-child {\n  margin-top: 0;\n}\n\n.article-detail-content h3 {\n  font-size: clamp(20px, 2.5vw, 26px);\n  font-weight: 500;\n  line-height: 1.4;\n  color: #F1F1F1;\n  margin-top: 36px;\n  margin-bottom: 20px;\n  letter-spacing: -0.01em;\n}\n\n.article-detail-content p {\n  margin-bottom: 20px;\n  color: rgba(241, 241, 241, 0.85);\n}\n\n.article-detail-content ul,\n.article-detail-content ol {\n  margin: 24px 0;\n  padding-left: 32px;\n}\n\n.article-detail-content li {\n  margin-bottom: 12px;\n  color: rgba(241, 241, 241, 0.85);\n  line-height: 1.7;\n}\n\n.article-detail-content ul li {\n  list-style-type: disc;\n}\n\n.article-detail-content ol li {\n  list-style-type: decimal;\n}\n\n.article-detail-content strong {\n  font-weight: 600;\n  color: #F1F1F1;\n}\n\n.article-detail-content a {\n  color: #CCFF00;\n  text-decoration: underline;\n  transition: opacity 0.3s ease;\n}\n\n.article-detail-content a:hover {\n  opacity: 0.8;\n}\n\n/* Actions */\n.article-detail-actions {\n  display: flex;\n  justify-content: flex-start;\n  margin-top: 60px;\n  padding-top: 40px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.article-detail-back-btn {\n  padding: 14px 32px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: transparent;\n  color: #F1F1F1;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Satoshi', sans-serif;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.article-detail-back-btn:hover {\n  background: #CCFF00;\n  color: #121212;\n  border-color: #CCFF00;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .article-detail-page {\n    padding-top: 100px;\n  }\n\n  .article-detail {\n    padding: 0 20px 60px;\n  }\n\n  .article-detail-header {\n    margin-bottom: 40px;\n  }\n\n  .article-detail-image {\n    height: 300px;\n    margin-bottom: 32px;\n  }\n\n  .article-detail-content {\n    font-size: 16px;\n    margin-bottom: 40px;\n  }\n\n  .article-detail-content h2 {\n    margin-top: 36px;\n    margin-bottom: 20px;\n  }\n\n  .article-detail-content h3 {\n    margin-top: 28px;\n    margin-bottom: 16px;\n  }\n\n  .article-detail-content ul,\n  .article-detail-content ol {\n    padding-left: 24px;\n  }\n\n  .article-detail-actions {\n    margin-top: 40px;\n    padding-top: 32px;\n  }\n}\n\n@media (max-width: 480px) {\n  .article-detail {\n    padding: 0 16px 40px;\n  }\n\n  .article-detail-image {\n    height: 250px;\n    margin-bottom: 24px;\n  }\n\n  .article-detail-content {\n    font-size: 15px;\n  }\n\n  .article-detail-content h2 {\n    margin-top: 32px;\n    margin-bottom: 16px;\n  }\n\n  .article-detail-content h3 {\n    margin-top: 24px;\n    margin-bottom: 12px;\n  }\n\n  .article-detail-content ul,\n  .article-detail-content ol {\n    padding-left: 20px;\n  }\n\n  .article-detail-back-btn {\n    padding: 12px 24px;\n    font-size: 14px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
